import { FC, useCallback } from 'react';
import { toNumber } from 'lodash';
import { createBemBlockBuilder } from '@ebsco-ui/ebsco-ui';

import {
  ResultWithSortAndPagination,
  searchResultSortItems,
  SortField,
} from '@app/components';
import { useSearchContext } from '@app/contexts';
import { defaultRecordsPerPage, SortDirection } from '@app/constants';

const cnBem = createBemBlockBuilder(['searchResultsPage']);

export const SearchResultsControls: FC = () => {
  const {
    state: {
      sortField = SortField.relevance,
      sortDirection = SortDirection.asc,
      pageNumber,
      recordsPerPage = defaultRecordsPerPage,
    },
    searchResults: { totalRecords },
    searchOption,
    shouldRefocusRef,
    updateState,
  } = useSearchContext();

  const handleSortBySelect = useCallback(
    option => {
      updateState({
        sortField: option.sortField,
        sortDirection: option.sortDirection,
        option: searchOption,
      });

      shouldRefocusRef.current = true;
    },
    [updateState, searchOption, shouldRefocusRef]
  );

  const handleRecordsPerPageChange = useCallback(
    option => {
      updateState({
        recordsPerPage: toNumber(option.selectedItem.value),
      });

      shouldRefocusRef.current = true;
    },
    [updateState, shouldRefocusRef]
  );

  return (
    <ResultWithSortAndPagination
      recordsCount={totalRecords}
      recordsPerPage={recordsPerPage}
      pageNumber={pageNumber}
      countMessage={{
        id: 'searchResults.results',
        defaultMessage:
          'Results: <b>{startNumber}-{endNumber}</b> of <b>{totalRecords}</b>',
      }}
      sortField={sortField}
      sortDirection={sortDirection}
      sortOptions={searchResultSortItems}
      titleLevel={1}
      className={cnBem('__controlsWrapper')}
      onSortChange={handleSortBySelect}
      onRecordsPerPageChange={handleRecordsPerPageChange}
    />
  );
};
